
export default {
  data() {
    return {
      msg: {},
      showLoading:true
    }
  },
  created() {
    this.query()
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.onClickLeft, false)
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.onClickLeft, false)
  },
  beforeUpdate() {
    if (this.$store.state.daili === 1) {
      this.$router.replace('popularizeinfo')
    } else {
      this.query()
    }
  },
  methods: {
    onClickLeft() {
      if(this.$store.state.daili !== 1){
        this.$router.replace('/mobile')
      }
    },
    async query() {
      const { data } = await this.$http.get('/extension/query')
      if (data.status === 'success') {
        this.msg = data.data
      } else {
        this.$notify({type:'danger',message:data.msg})
      }
      this.showLoading = false
    },
    // 申请推广
    async getDaili() {
      const { data } = await this.$http.post('/extension/extensiondata')
      if (data.status === 'success') {
        this.$notify({type:'success',message:'开通成功'})
        this.$store.commit('setOther', {
          name: 'daili',
          value: 1
        })
        this.$router.replace('popularizeinfo')
      } else {
        this.$notify({type:'danger',message:data.msg,duration: 1000})
      }
    }
  },
}
